import { render, staticRenderFns } from "./ModalSelectGroup.vue?vue&type=template&id=2851f478&scoped=true&"
import script from "./ModalSelectGroup.vue?vue&type=script&lang=js&"
export * from "./ModalSelectGroup.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelectGroup.vue?vue&type=style&index=0&id=2851f478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2851f478",
  null
  
)

export default component.exports